import { render, staticRenderFns } from "./learning-expectation-rating.vue?vue&type=template&id=c4f2d084&scoped=true"
import script from "./learning-expectation-rating.vue?vue&type=script&lang=js"
export * from "./learning-expectation-rating.vue?vue&type=script&lang=js"
import style0 from "./learning-expectation-rating.vue?vue&type=style&index=0&id=c4f2d084&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2d084",
  null
  
)

export default component.exports